<template>
  <div class="box tqm">
    <div class="box-head bg-color1 felx-between">
      <div class="box-head-title color1 flex-algin">
        <!-- 质量分项验收管理
        <i class="el-icon-arrow-down color1" style="margin-left:10px;"></i>-->
        <!-- <ul>
                    <li>质量分项验收管理</li>
                    <li>质量分部验收管理</li>
                </ul>
        <i class="el-icon-arrow-down color1" style="margin-left:10px;"></i>-->
        <!-- <el-select
          v-model="type"
          popper-class="fen-sel"
          class="fen-val"
          placeholder="选择检索项目"
          @change="doFilte"
        >
          <el-option v-for="item in tqmTypes" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select> -->
        <p>申请验收</p>
      </div>
      <!-- <el-button type="primary" class="bg-color2" @click="toInfo">验收</el-button> -->
    </div>
    <div class="box-table">
      <el-table
        :data="tableList"
        height = '100%'
        style="width: 100%;"
        
      >
        <el-table-column prop="projectName" label="来源项目" align="center"></el-table-column>
        <el-table-column prop="acceptanceContent" label="检查事项" align="center"></el-table-column>
        <!-- <el-table-column prop="address" label="验收次数" align="center"></el-table-column> -->
        <el-table-column prop="createDate" label="检查时间" align="center"></el-table-column>
        <el-table-column prop="handlerName" label="检查人" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope" v-if="scope.row.id">
            <el-button v-if="scope.row.status=='0'" style="color:#409EFF;" @click="toApplyFun(scope.row)">申请处理</el-button>
            <el-button
              size="mini"
              type="danger"
              class="bg-color3"
              v-if="scope.row.status=='1'&&scope.row.standardStatus=='1'"
            >未达标</el-button>
            <el-button size="mini" type="primary" class="bg-color4" v-else-if="scope.row.status=='1'&& scope.row.standardStatus=='0'">达标</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="width:100%;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5, 10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalItems"
        style="padding-top:10px;"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import myHttp from '../../untils/port'
import util from '../../untils/util'
export default {
  data() {
    return {
      tableList: [],
      tableHeadCellName: 'table-head-cell',
      tableHeadRowName: 'table-head-row',
      tqmTypes: [
        { id: '0', name: '质量分项验收管理' },
        { id: '1', name: '质量分部验收管理' }
      ],
      type: '0',
      groupId: '',
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      joinType:'',
    }
  },
  mounted() {
    this.groupId = this.$store.state.groupId
    if ('' == this.groupId || undefined == this.groupId) {
      this.groupId = util.session.get('groupId')
    }
    this.joinType = util.session.get('roleId')=='3'?'3':'2'
    this.getData()
  },
  methods: {
    doFilte() {
      this.currentPage = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    //获取数据
    getData() {
      var that = this
      myHttp
        .selectProSubentryAcceptPage({
          entId: this.groupId,
          joinType: this.joinType,
          handlerId:util.session.get('user').username,
          acceptanceType: this.type,
          pageNum: this.currentPage,
          pageSize: this.pageSize
        })
        .then(function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.pageInfo.list || []
            var result = []
            for (var i = 0; i < list.length; i++) {
              list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
              result.push(list[i])
              // result.push({})
            }
            that.tableList = result
            if (that.totalItems == 0) {
              that.totalItems = resp.data.data.pageInfo.total
            }
          }
        })
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return 'full-row'
      } else if (rowIndex % 2 === 1) {
        return 'null-row'
      }
      return ''
    },
    //跳转详情
    toInfo() {
      if(this.joinType=='3'){
        this.$router.push({ path: '/cqmEntInfo/0/' + this.type })
      }else{
        this.$router.push({ path: '/cqmInfo/0/' + this.type })
      }
      
    },

    //跳转
    toApplyFun(row){
      if(this.joinType=='3'){
        this.$router.push({ path: '/cqmEntInfo/'+row.id+'/' + this.type })
      }else{
        this.$router.push({ path: '/cqmInfo/'+row.id+'/'+ this.type })
      }
    },
  }
}
</script>
<style scoped>
* {
  box-sizing: border-box;
}
.box {
  width: 100%;
  position: relative;
  height: calc(100vh - 170px);
  background: #fff;
}
.box-head {
  width: 100%;
  height: 40px;
  position: relative;
  display: flex;
  padding: 0 20px;
}
.box-table {
  width: 100%;
  height: calc(100% - 90px);
  position: relative;
  padding: 0.5vh;
  /* overflow: auto; */
}
.el-table .box-head-title {
  font-size: 16px;
}

.flex-algin {
  display: flex;
  align-content: center;
  align-items: center;
}
.felx-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.bg-color1 {
  background: #f5f5f5;
}
.bg-color2 {
  background: #0d2dff;
}
.bg-color3 {
  background: #ffbc01;
}
.bg-color4 {
  background: #36c635;
}
.color1 {
  color: #17b2fe;
}
</style>
<style>
    .tqm .el-table .table-head-cell,
    .tqm .table-head-row {
      background: #fff;
      color: #4c9aff;
      font-size: 18px;
      text-align: center;
    }
    .tqm .el-table .full-row {
      background: #fbfbfb !important;
      /* color: #4c9aff; */
      font-size: 18px;
      text-align: center;
    }
    .tqm .el-table .null-row {
      background: #fff !important;
      border: 0;
      height: 10px;
    }
    .tqm .el-table .el-table__empty-block {
      background: #fbfbfb;
      color: #4c9aff;
      font-size: 18px;
      border: 0;
    }
    /* .tqm .el-table td,
    .tqm .el-table th.is-leaf {
      border: 0;
    } */
    .tqm .el-table--enable-row-hover .el-table__body tr:hover > td,
    .tqm .el-table,
    .tqm .el-table__expanded-cell {
      background-color: inherit;
    }
    .fen-val .el-input__inner {
      background: transparent;
      border: 0;
      font-size: 16px;
      text-align: right;
      color: #4c9aff;
    }
    .fen-sel.el-popper {
      background: #fff;
      margin-top: 1px;
      border: 0;
    }
    /* .fen-sel .el-select-dropdown__empty {
      color: #fff;
    } */
    .fen-val.el-select .el-input {
      width: 200px;
    }
    .fen-sel .popper__arrow {
      display: none;
    }
    .fen-sel .el-select-dropdown__item {
      border: 0;
      /* background: #010D27; */
      color: #4c9aff;
    }
    .fen-sel .el-select-dropdown__item.hover,
    .fen-sel .el-select-dropdown__item:hover {
      border: 0;
      background: #b6b6b6;
      color: #4c9aff;
    }
    .fen-sel .el-select-dropdown__list {
      padding: 0;
    }
    .tqm .el-pagination span {
      color: #000;
    }
    .tqm .el-pagination .el-input__inner {
      background: transparent;
      color: #000;
    }
    .tqm .el-table--border th, .el-table__fixed-right-patch{
        border-bottom: 1px solid #303133;
    }
    .tqm .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
        border-right: 1px solid #303133;
    }
    .tqm .el-table td, .el-table th.is-leaf{
        border-bottom: 1px solid #303133;
    }
    .tqm .el-table--border, .el-table--group{
        border: 1px solid #303133;
    }
</style>